import {
  Datagrid,
  EditButton,
  LongTextField,
  StateCollectionInput,
  useFieldLabel,
} from "ra-friendsofbabba";
import {
  DateField,
  List as RaList,
  TextField,
  usePermissions,
  useTranslate,
} from "react-admin";
import React, { Fragment } from "react";

import Actions from "../component/list/Actions";
import Empty from "../component/list/Empty";
import Filters from "./Filters";
import HelpBlock from "../component/HelpBlock";
import PrintButton from "./buttons/PrintButton";
import exporter from "./exporter";

const List = (props) => {
  const translate = useTranslate();
  const fieldLabel = useFieldLabel({ ...props });
  const { permissions, loaded } = usePermissions();
  const isRegion = loaded && permissions(["region"]);
  const isAdmin = loaded && permissions(["admin"]);

  return (
    <Fragment>
      <HelpBlock resource="projects" context="list" />
      <RaList
        {...props}
        empty={<Empty canCreate={!isRegion} />}
        actions={<Actions />}
        bulkActionButtons={false}
        exporter={(data) => exporter(data, translate)}
        perPage={10}
        sort={{ field: "SentProjectTransactions.created", order: "ASC" }}
        filters={<Filters />}
      >
        <Datagrid rowClick="edit">
          <TextField source="code" variant="body1" />
          {(isAdmin || isRegion) && (
            <LongTextField
              source="user.nice_name"
              label={fieldLabel("user_id")}
            />
          )}
          <StateCollectionInput
            source="state"
            readonly={!isAdmin}
            admin={isAdmin}
          />
          <LongTextField source="title" maxRows={2} />

          <TextField
            source="municipality.fullname"
            label={fieldLabel("municipality_id")}
            sortBy="Municipalities.name"
          />

          <DateField source="modified" showTime sortBy="Projects.modified" />
          {(isRegion || isAdmin) && (
            <DateField
              source="sent.created"
              emptyText="-"
              sortBy="SentProjectTransactions.created"
              showTime
            />
          )}
          {!isRegion && <PrintButton />}
          <EditButton />
        </Datagrid>
      </RaList>
    </Fragment>
  );
};

export default List;
